var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var dereferenceOfJson = function (jsondefinition, mainJson, resultantJson) {
    if (resultantJson === void 0) { resultantJson = {}; }
    var keys = Object.keys(jsondefinition);
    keys.forEach(function (item) {
        var _a, _b, _c;
        var value = jsondefinition[item];
        var type = typeof value;
        if (type === 'string') {
            if (item === '$ref') {
                var paths = value.split('#');
                var innerPaths = paths[1].split('/').filter(function (pathItem) { return !!pathItem; });
                if (paths[0].includes('.json')) {
                    var _json = require("./" + paths[0]);
                    var jsonData = dereferenceOfJson(nestedPathsValue(_json, innerPaths), mainJson, {});
                    resultantJson = __assign(__assign({}, resultantJson), jsonData);
                }
                else {
                    var jsonData = dereferenceOfJson(nestedPathsValue(mainJson, innerPaths), mainJson, {});
                    resultantJson = __assign(__assign({}, resultantJson), jsonData);
                }
            }
            else {
                resultantJson = __assign(__assign({}, resultantJson), (_a = {}, _a[item] = value, _a));
            }
        }
        else if (Array.isArray(value)) {
            var jsonData = value.map(function (datum) {
                return dereferenceOfJson(datum, mainJson, {});
            });
            resultantJson = __assign(__assign({}, resultantJson), (_b = {}, _b[item] = jsonData, _b));
        }
        else {
            resultantJson = __assign(__assign({}, resultantJson), (_c = {}, _c[item] = dereferenceOfJson(value, mainJson, {}), _c));
        }
    });
    return resultantJson;
};
var nestedPathsValue = function (json, paths) {
    var result = json;
    paths.forEach(function (path) {
        result = result[path];
    });
    return result;
};
//# sourceMappingURL=util.js.map